var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22,5.56l.4,4.79a.7.7,0,0,0,.7.64H12.6a.71.71,0,0,0,.69-.6L13.92,6a.4.4,0,0,0-.07-.3.41.41,0,0,0-.26-.15ZM5.32,12a1.71,1.71,0,0,1-1.7-1.56L3,3.17,2,3a.5.5,0,1,1,.17-1l1.38.24A.5.5,0,0,1,4,2.7l.15,1.86,9.6,0a1.37,1.37,0,0,1,.92.55,1.39,1.39,0,0,1,.26,1l-.63,4.37A1.71,1.71,0,0,1,12.6,12H5.32Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52,8H9.68a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.84a.5.5,0,0,1,.5.5A.5.5,0,0,1,11.52,8Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,13.8a.36.36,0,0,1,.36.36.36.36,0,1,1-.72,0A.36.36,0,0,1,5,13.8Z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5,15a.87.87,0,1,1,.86-.87A.86.86,0,0,1,5,15Z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55,13.8a.36.36,0,0,1,.36.36.36.36,0,1,1-.72,0A.36.36,0,0,1,12.55,13.8Z",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55,15a.87.87,0,1,1,.86-.87A.86.86,0,0,1,12.55,15Z",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.97ce0537b7bc870f2c53908a86c384df.svg";
export { ForwardRef as ReactComponent };